import _ from 'lodash';
import React from 'react';
import {connect} from 'react-redux';

import {default as Modal, withModal} from 'components/Modal';

import {
  MODALS,
  selectTenancyPeriod,
  selectPrimaryTenant,
  confirmTermination,
  fetchEarlyTerminations,
  fetchRoomAllocations,
  selectTerminatingTenancy
} from 'ducks/tenancy';
import {fetchBooking} from 'ducks/bookings';

import {
  Buttons,
  TerminationsTable,
  AllocationToUpdate,
  AllocationToDelete
} from './components';

import './styles.css';

class ConfirmTerminationModal extends React.Component<any> {
  getConfirmTerminationExtraActions = () => [
    ...this.props.closeModalExtraActions,
    () => fetchRoomAllocations({tenancyId: this.props.tenancyId}),
    () => fetchEarlyTerminations({tenancyId: this.props.tenancyId}),
    () =>
      fetchBooking({
        bookingId: this.props.bookingId,
        locationRef: this.props.locationRef
      })
  ];

  terminateTenancy = () => {
    const {tenancyId, data} = this.props;

    this.props.confirmTermination(
      {
        tenancyId,
        ...data.submitData
      },
      this.getConfirmTerminationExtraActions()
    );
  };

  getToUpdateHeader = predictData => {
    if (
      !_.isEmpty(predictData.allocationsToBeUpdated) ||
      !_.isEmpty(predictData.offlinePeriodsToBeUpdated)
    ) {
      return 'Allocations to be updated';
    }

    return '';
  };

  getToDeleteHeader = predictData => {
    if (
      !_.isEmpty(predictData.allocationsToBeDeleted) ||
      !_.isEmpty(predictData.offlinePeriodsToBeDeleted)
    ) {
      return 'Allocations to be deleted';
    }

    return '';
  };

  render() {
    const {
      data: {predictData, submitData},
      primaryTenant,
      period,
      terminatingTenancy
    } = this.props;
    const toUpdateHeader = predictData && this.getToUpdateHeader(predictData);
    const toDeleteHeader = predictData && this.getToDeleteHeader(predictData);

    return (
      <Modal
        show={true}
        onClose={this.props.closeModal}
        className="ConfirmTerminationModal"
        type={Modal.EXTRA_SMALL}>
        <Modal.Header heading="Confirm Termination" />

        {submitData &&
          predictData && (
            <Modal.Body>
              <TerminationsTable
                primaryTenant={primaryTenant}
                tenancyPeriod={period}
                departureDate={submitData.departureDate}
                terminationDate={submitData.terminationDate}
              />

              {toUpdateHeader && (
                <div className="messageHeader">{toUpdateHeader}</div>
              )}

              {predictData.allocationsToBeUpdated.map(allocation => (
                <AllocationToUpdate
                  key={_.get(allocation, 'original.id')}
                  allocation={allocation}
                  header="Room allocation"
                />
              ))}

              {predictData.offlinePeriodsToBeUpdated.map(offlinePeriod => (
                <AllocationToUpdate
                  key={_.get(offlinePeriod, 'original.id')}
                  allocation={offlinePeriod}
                  header="Out of Order Period - Turnaround"
                />
              ))}

              {toDeleteHeader && (
                <div className="messageHeader">{toDeleteHeader}</div>
              )}

              {predictData.allocationsToBeDeleted.map(allocation => (
                <AllocationToDelete
                  key={_.get(allocation, 'id')}
                  allocation={allocation}
                  header="Room allocation"
                />
              ))}

              {predictData.offlinePeriodsToBeDeleted.map(offlinePeriod => (
                <AllocationToDelete
                  key={_.get(offlinePeriod, 'id')}
                  allocation={offlinePeriod}
                  header="Out of Order Period - Turnaround"
                />
              ))}
            </Modal.Body>
          )}
        <Modal.Footer>
          <Buttons
            closeModal={this.props.closeModal}
            terminateTenancy={this.terminateTenancy}
            submitting={terminatingTenancy}
          />
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  const primaryTenant = selectPrimaryTenant(state);
  const period = selectTenancyPeriod(state);
  const terminatingTenancy = selectTerminatingTenancy(state);

  return {
    primaryTenant,
    period,
    terminatingTenancy
  };
};

const mapDispatchToProps = {
  confirmTermination
};

export default connect(mapStateToProps, mapDispatchToProps)(withModal(
  MODALS.CONFIRM_TERMINATION
)(ConfirmTerminationModal) as React.ComponentType<any>);
